import type { OutputData } from '@editorjs/editorjs';
import { z } from 'zod';

import { getBlockText } from '../../../lib/getBlockText.ts';

export const schema = z.object({
  name: z.string().min(1),
  category: z.string().min(1),
  tags: z.array(z.string()),
  description: z.custom<OutputData>().or(z.object({})),
  eventDetails: z.array(z.string()),
});

export const schemaWithDescriptionRefinement = schema.refine(
  (data) =>
    !(
      !data.description || // Ensure description exists
      !('blocks' in data.description) || // Confirm 'blocks' property is present in description
      (data.description.blocks?.length ?? 0) < 1 || // Check that 'blocks' has at least one item
      getBlockText(data.description.blocks?.[0]) === ''
    ),

  { message: 'required', path: ['description'] },
);
